<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Relevamientos</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Relevamiento</v-tab>
          <v-tab
            :disabled="
              !currentItem || editMode === 'edit' || editMode === 'new'
            "
          >
            Cultivo
          </v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn color="warning" outlined @click="cancel" class="mx-2">
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show'"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          color="success"
          outlined
          @click="save"
          clss="mx-2"
        >
          Guardar
        </v-btn>
      </div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text v-show="currentTab === 0">
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Productor"
            :search-input.sync="searchProducer"
            :items="producerItems"
            :loading="isLoadingProducer"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            return-object
            @change="producerSelected($event)"
            @click:prepend="clearAutocomplete('producerAutocomplete')"
            ref="producerAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Agentes"
            :search-input.sync="searchCommercialPerson"
            :items="commercialPersonItems"
            :loading="isLoadingCommercialPerson"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            return-object
            @change="commercialPersonSelected($event)"
            @click:prepend="clearAutocomplete('commercialPersonAutocomplete')"
            ref="commercialPersonAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Territorio"
            :search-input.sync="searchTerritory"
            :items="territoryItems"
            :loading="isLoadingTerritory"
            hide-details
            hide-no-data
            hide-selected
            no-filter
            item-text="description"
            item-value="territory"
            return-object
            v-model="selectedTerritory"
            @change="territorySelected($event)"
            @click:prepend="clearAutocomplete('territoryAutocomplete')"
            ref="territoryAutocomplete"
            prepend-icon="mdi-close"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.description"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.description_type"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            v-model="selectedCrop"
            @change="cropSelected($event)"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            :loading="isLoadingCampaign"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            return-object
            v-model="selectedCampaign"
            @change="campaignSelected($event)"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
        </v-toolbar>
        <!-- table header pagination and add button -->
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ activationEvents }">
              <v-btn
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="activationEvents"
                @click="addNew"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ activationEvents }">
              <v-btn
                :loading="downloading"
                :disabled="downloading"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="activationEvents"
                @click="exportToExcel"
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span>Exportar</span>
          </v-tooltip>
        </div>
        <!-- data table -->
        <v-data-table
          dense
          v-bind:page="page"
          :pageCount="this.pageCount"
          :loading="loading"
          :headers="headers"
          :items="items"
          :itemsPerPage="itemsPerPage"
          :serverItemsLength="serverItemsLength"
          :options.sync="options"
          @click:row="itemSelected($event, false)"
        >
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer
              :pagination="pagination"
              :options="options"
              @update:options="updateOptions"
            />
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-show="canEdit"
              small
              class="mr-2"
              @click.stop="itemSelected(item, true)"
            >
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click.stop="viewCrops(item)">
              mdi-corn
            </v-icon>
            <v-icon v-show="canDelete" small @click.stop="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <!-- tab1 edit survey -->
    <div v-if="currentTab === 1">
      <survey-edit
        :initialmode="editMode"
        :value="currentItem"
        :key="currentTab"
        ref="itemEdit"
        @endEdit="endEdit"
      >
      </survey-edit>
    </div>
    <!-- tab2 edit surveyCampaign -->
    <div v-if="currentTab === 2">
      <survey-campaign
        :currentSurvey="currentItem"
        :useDefaults="useDefaultCrop"
        :parentFilterCrop="filterCrop"
        :parentFilterCampaign="filterCampaign"
        @useDefaults="surveyCampaignUseDefaultsChange($event)"
        ref="surveyCampaign"
      >
      </survey-campaign>
    </div>
  </v-card>
</template>
<script>
import DataSurvey from "@/components/clon/DataSurvey.js";
import SurveyEdit from "@/components/SurveyEdit.vue";
import SurveyCampaign from "@/components/SurveyCampaign.vue";
import XLSX from "xlsx";

export default {
  name: "Survey",

  components: {
    SurveyEdit,
    SurveyCampaign
  },

  data() {
    return {
      currentTab: 0,
      editMode: "show",
      defaultOrder: "producer_name",
      currentItem: null,
      searchProducer: null,
      searchCommercialPerson: null,
      searchTerritory: null,
      producerItems: [],
      commercialPersonItems: [],
      territoryItems: [],
      campaignItems: [],
      cropItems: [],
      lastEndpoint: null,
      selectedTerritory: null,
      selectedCampaign: null,
      useDefaultTerritory: false,
      useDefaultCrop: false,
      isLoadingProducer: false,
      isLoadingCommercialPerson: false,
      isLoadingTerritory: false,
      isLoadingCampaign: false,
      isLoadingCrop: false,
      filterProducer: null,
      filterCommercialPerson: null,
      filterTerritory: null,
      filterCrop: null,
      selectedCrop: null,
      filterCampaign: null,
      loading: true,
      mounting: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 100,
      options: {},
      items: [],
      survey: new DataSurvey(this.$bRoot),
      headers: [],
      canEdit: true,
      canDelete: false,
      downloading: false
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler(options) {
        let order_by = "";
        let order_desc = 0;

        if (options.sortBy.length > 0) {
          order_by = options.sortBy[0];
          order_desc = options.sortDesc[0] ? 1 : 0;
        } else {
          order_by = this.defaultOrder;
          order_desc = 0;
        }
        this.readDataFromAPI(false, order_by, order_desc);
      }
    },
    searchProducer: {
      handler(val) {
        this.doIntelliSearch("producer", val);
      }
    },
    searchCommercialPerson: {
      handler(val) {
        this.doIntelliSearch("commercial_person", val);
      }
    },
    searchTerritory: {
      handler(val) {
        if (this.useDefaultTerritory === false) {
          this.doIntelliSearch("territory", val);
        }
      }
    },
    deep: true
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI(reset, order_by, order_desc) {
      if (!this.mounting) {
        try {
          order_by = order_by ? order_by : this.defaultOrder;
          order_desc = order_desc ? order_desc : 0;
          const { page, itemsPerPage } = this.options;
          let pageNumber = reset ? 1 : page;
          this.loading = true;

          this.headers = [
            {
              text: "Productor",
              value: "producer_name",
              sortable: true,
              width: "30%"
            },
            {
              text: "Agente",
              value: "commercial_person_name",
              sortable: false
            },
            {
              text: "Tipo Territorio",
              value: "territory_type_description",
              sortable: false
            },
            {
              text: "Territorio",
              value: "territory_description",
              sortable: false
            },
            {
              // eslint-disable-next-line
              text: "ha " + (this.filterCampaign ? this.filterCampaign.previous_campaign_code : "?"),
              value: "previous_hectares",
              sortable: true,
              align: "right"
            },
            {
              // eslint-disable-next-line
              text: "ha " + (this.filterCampaign ? this.filterCampaign.code : "?"),
              value: "actual_hectares",
              sortable: true,
              align: "right"
            },
            { text: "Acciones", value: "actions", sortable: false }
          ];

          let endpoint =
            "/data/surveys_hierarchy_campaign_crop/" +
            // eslint-disable-next-line
            (this.filterCampaign ? this.filterCampaign.id.toString() : "0") + "/" +
            // eslint-disable-next-line
            (this.filterCrop ? this.filterCrop.id.toString() : "0") + "/" +
            // eslint-disable-next-line
            (this.filterProducer ? this.filterProducer.id.toString() : "0") + "/" +
            // eslint-disable-next-line
            (this.filterCommercialPerson ? this.filterCommercialPerson.commercial_id.toString() : "0") + "/"

          if (this.filterTerritory) {
            switch (this.filterTerritory.level) {
              case 0:
                // eslint-disable-next-line
                endpoint = endpoint + this.filterTerritory.id.toString() + "/0/0/0"
                break;
              case 1:
                // eslint-disable-next-line
                endpoint = endpoint + "0/" + this.filterTerritory.id.toString() + "/0/0"
                break;
              case 2:
                // eslint-disable-next-line
                endpoint = endpoint + "0/0/" + this.filterTerritory.id.toString() + "/0"
                break;
              case 3:
                // eslint-disable-next-line
                endpoint = endpoint + "0/0/0/" + this.filterTerritory.id.toString()
                break;
            }
          } else {
            endpoint = endpoint + "0/0/0/0";
          }
          /*Ordenamiento*/
          endpoint = endpoint + "/" + order_by;
          endpoint = endpoint + "/" + order_desc.toString();

          this.lastEndpoint = endpoint;

          let res = await this.$bRoot.search(
            endpoint,
            null,
            null,
            null,
            pageNumber
          );
          if (this.$bRoot.errors) {
            throw "Error recuperando datos";
          }
          if (res) {
            this.items = res.data.results;
            this.serverItemsLength = res.data.count;
            this.page = pageNumber;
            this.pageCount = Math.ceil(res.data.count / itemsPerPage);
          }
        } catch (error) {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        } finally {
          this.loading = false;
        }
      }
    },

    doIntelliSearch(field, val) {
      // Items have already been requested
      if (this.isLoading) return;

      // Lazily load input items
      let endpoint = null;
      let searchstring = null;
      let filterstring = null;
      let ordering = null;

      switch (field) {
        case "producer":
          if (this.filterProducer) {
            if (this.filterProducer.name === val) return;
          }
          endpoint = "/data/producers";
          searchstring = val;
          ordering = "name";
          this.isLoadingProducer = true;
          break;
        case "commercial_person":
          if (this.filterCommercialPerson) {
            if (this.filterCommercialPerson.name === val) return;
          }
          endpoint = "/data/commercial_persons_hierarchy";
          searchstring = null;
          ordering = "name";
          filterstring = "commercial_type_level=3&name__icontains=" + val;
          this.isLoadingCommercialPerson = true;
          break;
        case "territory":
          if (this.filterTerritory) {
            if (this.filterTerritory.description === val) return;
          }
          endpoint = "/data/territories_hierarchy";
          searchstring = null;
          ordering = "level,description";
          val = val ? val : "";
          if (val.split(",").length > 1) {
            val.split(",").forEach((element, index) => {
              if (index <= 3) {
                // eslint-disable-next-line
                filterstring = (filterstring ? filterstring + "&" : "") + "level" + (3 - index).toString() + "_description__icontains=" + element;
              }
            });
          } else {
            searchstring = val;
          }
          this.isLoadingTerritory = true;
          break;
      }

      // eslint-disable-next-line
      this.$bRoot.search(endpoint, searchstring, ordering, filterstring, 1)
        .then(res => {
          switch (field) {
            case "producer":
              this.producerItems = res.data.results;
              break;
            case "commercial_person":
              this.commercialPersonItems = res.data.results;
              break;
            case "territory":
              this.territoryItems = res.data.results;
              break;
          }
        })
        .catch(err => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(err);
          }
        })
        .finally(() => {
          this.isLoadingProducer = false;
          this.isLoadingCommercialPerson = false;
          this.isLoadingTerritory = false;
        });
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "producerAutocomplete":
          this.filterProducer = null;
          break;
        case "commercialPersonAutocomplete":
          this.filterCommercialPerson = null;
          break;
        case "territoryAutocomplete":
          this.filterTerritory = null;
          this.useDefaultTerritory = false;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          this.useDefaultCrop = false;
          break;
        case "campaignAutocomplete":
          this.filterCampaign = null;
          break;
      }
      this.readDataFromAPI(true);
    },

    producerSelected(item) {
      this.filterProducer = item;
      this.readDataFromAPI(true);
    },

    commercialPersonSelected(item) {
      this.filterCommercialPerson = item;
      this.readDataFromAPI(true);
    },

    territorySelected(item) {
      this.filterTerritory = item;
      this.readDataFromAPI(true);
    },

    cropSelected(crop) {
      this.filterCrop = crop;
      this.readDataFromAPI(true);
    },

    campaignSelected(campaign) {
      this.filterCampaign = campaign;
      this.readDataFromAPI(true);
    },

    deleteItem(item) {
      this.$emit("deleteItem", item);
    },

    itemSelected(item, edit) {
      this.editMode = edit ? "edit" : "show";
      this.currentItem = item;
      this.currentTab = 1;
    },

    viewCrops(item) {
      this.currentItem = item;
      this.editMode = "show";
      this.currentTab = 2;
    },

    surveyCampaignUseDefaultsChange(value) {
      this.useDefaultCrop = value;
    },

    async addNew() {
      this.currentItem = await this.survey.initialize(
        this.filterProducer,
        this.filterTerritory,
        this.filterCommercialPerson
      );
      this.editMode = "new";
      this.currentTab = 1;
    },

    async cancel() {
      // eslint-disable-next-line
      if(this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    },

    endEdit(object) {
      if (!object) {
        this.editMode = null;
        this.currentItem = null;
        this.error = null;
        this.currentTab = 0;
      } else {
        this.currentItem = object;
        this.editMode = "show";
      }
    },

    save() {
      this.$refs.itemEdit.save();
    },

    async exportToExcel() {
      try {
        this.downloading = true;
        if (this.lastEndpoint) {
          // eslint-disable-next-line
          let raw = await this.$bRoot.searchAll(this.lastEndpoint, null, null, null);
          let datos = [];
          let previous = null;
          let actual = null;
          if (this.filterCampaign) {
            previous =
              "Hectáreas_" + this.filterCampaign.previous_campaign_code;
            actual = "Hectáreas_" + this.filterCampaign.code;
          }
          raw.map(item => {
            let element = {
              Productor_CUIT: item.producer_identification,
              Productor_Nombre: item.producer_name,
              Agente: item.commercial_person_name,
              Territorio: item.territory_description,
              Territorio_Tipo: item.territory_type_description,
              Contacto_Nombre: item.contact_name,
              Contacto_Email: item.contact_email,
              Contacto_Teléfono: item.contact_phone,
              Cultivo: this.filterCrop ? this.filterCrop.description : "?"
            };
            if (this.filterCampaign) {
              element[previous] = item.previous_hectares;
              element[actual] = item.actual_hectares;
            }
            datos.push(element);
          });
          let datosWS = XLSX.utils.json_to_sheet(datos);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "relevamientos");
          XLSX.writeFile(wb, "relevamientos.xlsx");
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.downloading = false;
      }
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    /*Territories*/
    let defaultTerritory = this.$bRoot.getUserParam("defaultTerritory");

    if (defaultTerritory) {
      let res = await this.$bRoot.search(
        "/data/territories_hierarchy",
        null,
        "level,description",
        "description__icontains=" + defaultTerritory
      );
      if (res.data.results.length > 0) {
        this.useDefaultTerritory = true;
        this.territoryItems = res.data.results;
        this.selectedTerritory = res.data.results[0].territory;
        this.filterTerritory = res.data.results[0];
      }
    }

    //crops
    let crops = await this.survey.getCrops();
    this.cropItems = crops.data.results;

    let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
    if (defaultCropId > 0) {
      this.useDefaultCrop = true;
      let index = crops.data.results.findIndex(
        crop => crop.id === defaultCropId
      );
      if (index !== -1) {
        this.filterCrop = crops.data.results[index];
        this.selectedCrop = crops.data.results[index].url;
      }
    }

    //campaigns
    let campaigns = await this.survey.getCampaigns();
    this.campaignItems = campaigns.data.results;
    let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
    let index = this.campaignItems.findIndex(
      item => item.id == defaultCampaignId
    );
    if (index == -1 && this.campaignItems.length > 0) {
      index = 0;
    }
    if (index !== -1) {
      this.selectedCampaign = this.campaignItems[index].url;
      this.filterCampaign = this.campaignItems[index];
    }
    this.mounting = false;
    await this.readDataFromAPI();
  }
};
</script>

<style>
.v-data-footer__select {
  visibility: hidden !important;
}
.v-data-footer:last-child {
  visibility: hidden !important;
}
.table-footer-prepend {
  height: 58px;
}
.v-data-table {
  margin-top: -58px;
}
</style>
